import VimeoCardPlayer from "@/components/Video/VimeoCardPlayer";
import { SingularFaqList } from "./SingularFaqList";
import { SingularCompatibleBadge } from "./SingularCompatibleBadge";

/*
desktopId  - video name                              - mobileId
1125588423 - 510 adapter for standard carts          - 1125593380
1125588645 - Built by cannabis people                - 1125593592
1125588958 - Eco-conscious materials                 - 1125593878
1125589348 - Feel the tech with haptic feedback      - 1125594282
1125589585 - Flavor swapping made easy               - 1125594587
1125589850 - Pick your power with adjustable voltage - 1125594937
1125590121 - Pods tuned to the extract inside        - 1125595239
1125590552 - Preheat function fights clogs           - 1125595633
1125590857 - Refills cost less                       - 1125595847
1125591114 - Smart pod recognition                   - 1125596073
1125591444 - Stay connected with NFC technology      - 1125596425
1125591848 - The future of vape                      - 1125596729
1125592361 - The more sustainable vape               - 1125597262
1125592599 - World's first universal vape platform   - 1125597509
*/

export const singularBtbFAQ = [
  {
    order: 1,
    question: "What makes Singular by ACTIVE different from other pod systems?",
    answer:
      "Unlike other pods systems, Singular is universal. As an open pod system it works with all Singular batteries across product lines and brands. This gives your brand, and consumers more flexibility and optionality.",
    additionalNode: (
      <div>
        <VimeoCardPlayer
          vimeoId={1125591848}
          mobileVimeoId={1125596729}
          thumbnailName="thumb-future-of-vape.png"
          cardTitle="The Future of Vape"
        />
      </div>
    ),
  },
  {
    order: 1,
    question: "What are some of the advantages of the Singular platform?",
    answer:
      "By operating within a single platform, singular simplifies your SKU strategy and operations. Singular is compatible with multiple extracts reducing the need for multiple hardware suppliers. This streamlines purchasing, standardizes filling and capping, and ultimately frees up working capital with lower inventory holding costs.<br/><br/>Because Singular pods are compatible with all Singular batteries, it has the potential to unlock new revenue sources through cross-selling opportunities within your house of brands and other brand partnerships.",
  },
  {
    order: 1,
    question: "How do I get brand exclusivity with Singular?",
    answer:
      "Singular is the first pod system that allows brands to share a common platform but retain a unique look and feel through signature shapes, aesthetics, and features. Contact us to explore exclusive custom opportunities for your brand.",
  },
  {
    order: 1,
    question: "Which extracts is the Singular system best suited to?",
    answer:
      "Singular is designed to cater for almost every extract type. Singular pods include ceramic, postless, and stainless steel center post options with multiple capacities ranging from 0.5mL to 5.0mL.<br/><br/>So whether it’s distillate, live resin, or high-end solventless, there’s a pod built to match.",
    additionalNode: (
      <div>
        <VimeoCardPlayer
          vimeoId={1125590121}
          cardTitle="Pods tuned to the extract inside"
          thumbnailName="thumb-tuned-pods.png"
          mobileVimeoId={1125595239}
        />
      </div>
    ),
  },
  {
    order: 1,
    question: "Can you customize Singular pods to suit my specific extracts?",
    answer:
      "Yes. Based on your order volume, we can advise on and customize pods tailored to your unique extract type.",
  },
  {
    order: 1,
    question: "What makes Singular different from an all-in-one disposable?",
    answer:
      "Because Singular looks and feels like an all-in-one, it makes the customer transition to Singular easy. While offering customers familiar all-in-one convenience, customers also enjoy:",
    additionalNode: (
      <SingularFaqList
        points={[
          "Reusable batteries",
          "Singular pods are optimized for each extract type",
          "Better value for your customers replenishing pods and not batteries every time",
          "Less waste",
        ]}
      />
    ),
  },
  {
    order: 1,
    question: "Can Singular batteries be used with any Singular pod?",
    answer:
      "Yes, Singular is a universal platform and any Singular pod will work with any Singular battery. Customers should look out for the “Singular Compatible badge.”",
    additionalNode: <SingularCompatibleBadge />,
  },
  {
    order: 1,
    question: "Why is Singular better value for my customers?",
    answer:
      "With all-in-ones, people are forced to buy the battery component of an AIO every single time. This drives up the price. With Singular, they buy the battery once, and just swap pods. It means each refill costs less than a full all-in-one as customers do not pay the cost of a new lithium-ion battery at every purchase.",
    additionalNode: (
      <div>
        <VimeoCardPlayer
          vimeoId={1125590857}
          thumbnailName="thumb-refills.png"
          mobileVimeoId={1125595847}
          cardTitle="Refills cost less"
        />
      </div>
    ),
  },
  {
    order: 1,
    question: "What makes Singular better for our environment?",
    answer:
      "Because Singular batteries are reusable, the SIngular system reduces single-use waste. This not only future-proofs your brand against evolving AIO regulations and potential bans but also aligns it with current consumer sustainability trends.",
    additionalNode: (
      <div>
        <VimeoCardPlayer
          vimeoId={1125592361}
          thumbnailName="thumb-stustainable.png"
          mobileVimeoId={1125597262}
          cardTitle="The more sustainable vape"
        />
      </div>
    ),
  },
  {
    order: 1,
    question: "Does Singular have a pre-heat function?",
    answer:
      "Yes. Rapidly remove and reinsert the pod twice to activate a gentle pre-heat function.",
    additionalNode: (
      <div>
        <VimeoCardPlayer
          vimeoId={1125590552}
          thumbnailName="thumb-preheat.png"
          mobileVimeoId={1125595633}
          cardTitle="Preheat function fights clogs"
        />
      </div>
    ),
  },
  {
    order: 1,
    question: "Do Singular batteries have different flavor settings?",
    answer:
      "Yes. Customers are able to adjust the battery for different extracts and experiences. Each setting is indicated by a color LED:",
    additionalNode: (
      <>
        <p className="font-semibold">Axil S1</p>
        <SingularFaqList
          points={[
            "Blue is low (For flavor and terpenes)",
            "Yellow/orange is medium (For a well-rounded experience)",
            "Red is high (For big clouds)",
          ]}
        />
        <p className="font-semibold">Offset S1</p>
        <SingularFaqList
          points={["Voltage changes will be indicated on the screen."]}
        />
        <div>
          <VimeoCardPlayer
            vimeoId={1125589850}
            thumbnailName="thumb-active.png"
            mobileVimeoId={1125594937}
            cardTitle="Pick your power with adjustable settings"
          />
        </div>
      </>
    ),
  },
  {
    order: 1,
    question: "How do I adjust Singular’s flavor setting?",
    answer:
      "Quickly remove and reinsert the pod three times to cycle through the flavor settings.",
    additionalNode: (
      <div>
        <VimeoCardPlayer
          vimeoId={1125589850}
          thumbnailName="thumb-active.png"
          mobileVimeoId={1125594937}
          cardTitle="Pick your power with adjustable settings"
        />
      </div>
    ),
  },
  {
    order: 1,
    question: "Can customers use a 510 cartridge with a Singular battery?",
    answer:
      "Yes, we offer Singular 510 cartridge adapters that magnetically connect to any Singular battery. This adapter makes switching between regular 510 cartridges and Singular pods effortless. Simply screw a standard cartridge onto the 510 adapter and drop it into a Singular battery.",
    additionalNode: (
      <div>
        <VimeoCardPlayer
          vimeoId={1125588423}
          thumbnailName="thumb-510-adapter.png"
          mobileVimeoId={1125593380}
          cardTitle="510 adapter for standard cartridges"
        />
      </div>
    ),
  },
  {
    order: 1,
    question: "Do Singular devices include ACTIVE No-Burn Technology?",
    answer:
      "Yes. Singular devices incorporate our proprietary No-Burn Technology®. By combining an advanced heating core with precise temperature control, heat spikes are prevented, preserving the full, rich flavors and delicate character of your extracts.",
    additionalNode: (
      <div>
        <VimeoCardPlayer
          vimeoId={1125588645}
          thumbnailName="thumb-active.png"
          mobileVimeoId={1125593592}
          cardTitle="Built by cannabis people"
        />
      </div>
    ),
  },
  {
    order: 1,
    question: "Can I add custom tech features to Singular?",
    answer:
      "Yes. We can add NFC, haptic feature, custom weights, full color screens and other bespoke features. Speak to us to start your design process.",
  },
  {
    order: 1,
    question: "Why do some Singular battery vibrate during inhalation?",
    answer:
      "Some Singular batteries feature haptic feedback that confirms the battery is functioning properly during use. It provides a subtle, reassuring signal to your customer that the device is active and delivering consistent performance. This function enhances user confidence and experience.",
    additionalNode: (
      <div>
        <VimeoCardPlayer
          vimeoId={1125589348}
          thumbnailName="thumb-active.png"
          mobileVimeoId={1125594282}
          cardTitle="Feel the tech with haptic feedback"
        />
      </div>
    ),
  },
  {
    order: 1,
    question: "How do I fill the different Singular pods",
    answer: "",
    additionalNode: (
      <p>
        Please view our{" "}
        <a
          className="text-orange underline"
          href="/singular-filling-and-capping-directions"
        >
          fill and cap instructions
        </a>{" "}
        for full details.
      </p>
    ),
  },
  {
    order: 1,
    question: "What type of charger does the Singular battery require?",
    answer:
      "The Singular battery is USB-C rechargeable. Since most people have chargers, we don’t include one to help reduce waste. These can, however, be provided to you to include or offer at point of sale.",
  },
  {
    order: 1,
    question:
      "What certifications or compliance standards do Singular batteries meet?",
    answer: "Singular batteries are RoHs, CE, and FCC certified.",
  },
  {
    order: 1,
    question: "What is NFC technology in Singular devices?",
    answer:
      "NFC-enabled Singular devices come pre-programmed with a URL of your choice. With a simple tap of their phone, consumers can instantly engage with your brand. Direct them to your COA’s, Weedmaps (or other e-commerce) page, social media profiles, product education, or even a contest. A great feature to help your brand stay connected with your customers after the sale.",
    additionalNode: (
      <div>
        <VimeoCardPlayer
          vimeoId={1125591444}
          thumbnailName="thumb-active.png"
          mobileVimeoId={1125596425}
          cardTitle="Stay connected with NFC Technology"
        />
      </div>
    ),
  },
];
